import { SvgIconProps } from './icon-props';

export default function IconFsTree({
	height = 180,
	width = 118,
	fill = '#1F1F1F',
	className,
	role,
}: SvgIconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 117.91 180"
			fill="none"
			className={className}
			role={role}
		>
			<path
				fillRule="evenodd"
				d="M117.82,105.57c-3.16,1.3-5.17,3.61-4.39,7.54C117.23,111.84,118.24,109,117.82,105.57Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M105.09,107.88c.61,3.36,2.44,5.81,6.45,5.88C111.09,109.77,108.49,108.17,105.09,107.88Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M111.52,124c-.17-4-2.81-5.56-6.41-5.87C105.5,121.52,107.28,124,111.52,124Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M99.93,71.27c-3.41.3-6,1.9-6.45,5.88C97.48,77.09,99.33,74.64,99.93,71.27Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M84.51,68.34C85.12,71.7,87,74.15,91,74.21,90.52,70.24,87.92,68.64,84.51,68.34Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M83.61,56.07c4-.07,5.83-2.51,6.45-5.88C86.65,50.49,84,52.09,83.61,56.07Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M86.74,41.31c-3.14,1.35-5.11,3.69-4.27,7.61C86.23,47.59,87.21,44.69,86.74,41.31Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M75.48,44.16c.12,3.4,1.58,6.07,5.51,6.7C81.13,46.89,78.79,44.94,75.48,44.16Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M74,34.58c4-.06,5.82-2.51,6.44-5.86C77.05,29,74.46,30.61,74,34.58Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M77.37,20.65c-3,1.66-4.67,4.18-3.43,8C77.53,26.92,78.2,23.95,77.37,20.65Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M72.88,31.47c.13-4-2.21-5.93-5.52-6.7C67.49,28.17,69,30.84,72.88,31.47Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M70.7,37.24c-.43-4-3-5.55-6.42-5.85C64.9,34.75,66.72,37.18,70.7,37.24Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M57,6.08c-.44-4-3-5.55-6.42-5.85C51.21,3.58,53,6,57,6.08Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M56.93,12.56c-.44-4-3-5.55-6.42-5.84C51.12,10.07,52.94,12.5,56.93,12.56Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M56.83,19c-.44-4-3-5.55-6.42-5.85C51,16.5,52.85,19,56.83,19Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M56.73,25.48c-.44-4-3-5.54-6.42-5.84C50.93,23,52.75,25.42,56.73,25.48Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M56.63,32c-.44-4-3-5.55-6.41-5.85C50.83,29.47,52.65,31.9,56.63,32Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M56.54,38.42c-.44-4-3-5.55-6.42-5.85C50.73,35.92,52.55,38.35,56.54,38.42Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M47.93,23.67c-3.25,1.05-5.41,3.2-4.94,7.16C46.85,29.87,48.09,27.08,47.93,23.67Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M43.11,35.59c4-.07,5.81-2.5,6.42-5.85C46.14,30,43.54,31.63,43.11,35.59Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M41.55,31.58c.56-3.95-1.56-6.15-4.77-7.28C36.53,27.71,37.7,30.53,41.55,31.58Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M40.72,36.05c-.44-4-3-5.57-6.43-5.86C34.9,33.55,36.72,36,40.72,36.05Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M50.21,54.22c-3.4.3-6,1.89-6.45,5.88C47.76,60,49.6,57.58,50.21,54.22Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M39,57.66c4-.06,5.83-2.51,6.45-5.88C42.08,52.08,39.48,53.68,39,57.66Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M54.95,56.66c-3.41.29-6,1.9-6.45,5.88C52.49,62.47,54.33,60,54.95,56.66Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M46.48,50c4-.06,5.82-2.5,6.43-5.86C49.52,44.44,46.92,46,46.48,50Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M42,47.37c4-.06,5.82-2.5,6.44-5.86C45,41.81,42.39,43.41,42,47.37Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M37.35,44.72c4-.07,5.82-2.5,6.43-5.87C40.39,39.15,37.79,40.74,37.35,44.72Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M40.73,49.24c-3.4.29-6,1.89-6.45,5.87C38.28,55,40.12,52.6,40.73,49.24Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M33.09,48.87c.49-4-1.67-6.13-4.91-7.21C28,45.07,29.21,47.88,33.09,48.87Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M31.86,54.9c-.44-4-3-5.58-6.45-5.88C26,52.39,27.86,54.84,31.86,54.9Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M35.25,75.15c-3.4.29-6,1.89-6.44,5.87C32.81,80.95,34.64,78.51,35.25,75.15Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M24.21,78.4c4-.06,5.84-2.51,6.45-5.88C27.26,72.83,24.65,74.42,24.21,78.4Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M40,77.59c-3.41.3-6,1.9-6.45,5.88C37.52,83.4,39.36,81,40,77.59Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M44.71,80c-3.4.3-6,1.9-6.45,5.88C42.26,85.84,44.09,83.4,44.71,80Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M49.43,82.47c-3.4.3-6,1.9-6.45,5.88C47,88.28,48.82,85.83,49.43,82.47Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M54.18,84.89c-3.4.3-6,1.9-6.45,5.88C51.73,90.7,53.57,88.26,54.18,84.89Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M47.4,75.27c4-.07,5.84-2.51,6.45-5.88C50.45,69.7,47.85,71.29,47.4,75.27Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M42.82,72.59c4-.07,5.83-2.51,6.45-5.88C45.86,67,43.26,68.61,42.82,72.59Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M38.28,69.92c4-.07,5.84-2.51,6.45-5.87C41.32,64.34,38.72,65.94,38.28,69.92Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M33.75,67.24c4-.06,5.83-2.51,6.45-5.88C36.79,61.67,34.19,63.27,33.75,67.24Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M29.19,64.57c4-.07,5.83-2.51,6.45-5.88C32.23,59,29.63,60.58,29.19,64.57Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M30.53,66.54c-3.41.3-6,1.9-6.45,5.88C28.07,72.35,29.91,69.91,30.53,66.54Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M23.29,69.12c1-3.88-.91-6.29-4-7.76C18.7,64.73,19.57,67.67,23.29,69.12Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M22.22,74.27c-.44-4-3-5.58-6.45-5.88C16.39,71.76,18.22,74.21,22.22,74.27Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M21.34,80.15c-.44-4-3-5.58-6.45-5.88C15.5,77.63,17.34,80.08,21.34,80.15Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M32.46,96.51c4-.07,5.84-2.51,6.45-5.88C35.51,90.92,32.9,92.53,32.46,96.51Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M32.46,105.7c4-.07,5.84-2.51,6.45-5.88C35.51,100.12,32.91,101.72,32.46,105.7Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M27.95,93.85c4-.07,5.84-2.52,6.45-5.88C31,88.27,28.39,89.88,27.95,93.85Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M23.45,91.19c4-.07,5.83-2.52,6.45-5.88C26.49,85.61,23.89,87.2,23.45,91.19Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M19,88.55c4-.07,5.84-2.52,6.45-5.88C22,83,19.44,84.56,19,88.55Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M112.4,113.6a91.61,91.61,0,0,1,.43,9.24c-.2,3-.6,4.06-2.88,5.54L60.46,153.87h0c-.08-4.85-.18-10.4-.29-16.45v-1.6c-.06-3.32.85-5.1,4.77-7.58,3.4-2.16,39.93-23.52,39.93-23.52a.43.43,0,0,0,.21-.44L103.4,91.35h-.56a75.14,75.14,0,0,1,.35,7.62c-.16,2.48-.49,3.35-2.38,4.58l-40.87,21c-.11-6.26-.23-12.85-.35-19.58l0-1.83c.06-2.09.81-3.34,3.46-5S92.85,80.6,92.85,80.6a.31.31,0,0,0,.16-.33l-1.26-9.66h-.42a56.31,56.31,0,0,1,.26,5.69c-.12,1.85-.37,2.5-1.78,3.42L59.42,95.38c-.14-7.57-.27-15.22-.41-22.73a5.29,5.29,0,0,1,2.49-3.51C63.32,68,82.86,56.57,82.86,56.57a.22.22,0,0,0,.11-.23l-.9-6.92h-.3A40.67,40.67,0,0,1,82,53.49c-.09,1.33-.26,1.79-1.27,2.45L58.92,67.15c-.13-7-.25-13.76-.36-20.17a3.38,3.38,0,0,1,1.5-1.92c1.15-.73,13.5-7.95,13.5-7.95a.14.14,0,0,0,.07-.15l-.57-4.37h-.19A25.59,25.59,0,0,1,73,35.17c-.06.84-.17,1.13-.81,1.55l-13.69,7C58,18.77,57.71.21,57.71.21a.21.21,0,1,0-.41,0s-.75,42.9-.76,43.51l-13.6-7c-.64-.41-.75-.71-.81-1.55a25.57,25.57,0,0,1,.12-2.57h-.19L41.49,37a.15.15,0,0,0,.07.15s12.35,7.22,13.5,7.95a3.42,3.42,0,0,1,1.43,1.7h0c-.11,6.47-.23,13.32-.36,20.35L34.43,55.94c-1-.66-1.19-1.12-1.27-2.45a40.68,40.68,0,0,1,.19-4.08H33l-.9,6.92a.24.24,0,0,0,.11.24S51.79,68,53.61,69.14A5.32,5.32,0,0,1,56,72.37h0c-.13,7.59-.27,15.34-.4,23L25.25,79.73c-1.41-.92-1.66-1.57-1.78-3.42-.1-1.63.26-5.69.26-5.69h-.42l-1.26,9.66a.32.32,0,0,0,.16.33S49.5,96.56,52,98.17c2.73,1.72,3.43,3,3.46,5.22l0,2h0c-.11,6.62-.23,13.09-.33,19.25l-40.83-21c-1.89-1.22-2.22-2.1-2.38-4.58a76,76,0,0,1,.36-7.63h-.56L10,104.29a.43.43,0,0,0,.21.44s36.53,21.36,39.93,23.52c3.92,2.48,4.82,4.26,4.77,7.58v0c-.12,6.65-.22,12.73-.31,18L5.18,128.38c-2.29-1.49-2.69-2.54-2.88-5.54a91.86,91.86,0,0,1,.43-9.24H2L0,129.27a.51.51,0,0,0,.25.53s44.24,25.87,48.36,28.48c4.81,3,5.78,3.26,5.78,8.83,0,.26-.1,6.71-.1,6.95,0,4.86-3.85,5-3.85,5v1H64.64v-1s-3.85-.13-3.85-5c0-.24-.08-6.46-.08-6.95,0-5.57,1-5.79,5.78-8.83,4.12-2.61,48.36-28.48,48.36-28.48a.52.52,0,0,0,.25-.53l-2-15.67Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M41.78,102.06c4-.07,5.84-2.51,6.45-5.88C44.83,96.48,42.22,98.08,41.78,102.06Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M52.74,99.12c-3.41.29-6,1.9-6.45,5.88C50.29,104.93,52.12,102.49,52.74,99.12Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M76.82,85.82c3.13-2.49,3.1-5.55,1.53-8.59C75.83,79.55,74.74,82.4,76.82,85.82Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M70.34,81.47c-2.51,2.32-3.6,5.17-1.52,8.59C71.94,87.57,71.91,84.51,70.34,81.47Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M61.83,69.65c.61,3.37,2.44,5.81,6.45,5.88C67.84,71.55,65.24,70,61.83,69.65Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M84.82,96c-.44-4-3-5.58-6.44-5.88C79,93.49,80.82,95.93,84.82,96Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M76.74,100.36c-.44-4-3-5.58-6.44-5.88C70.91,97.85,72.74,100.29,76.74,100.36Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M99.38,132.67c-.44-4-3.05-5.59-6.46-5.89C93.53,130.16,95.37,132.61,99.38,132.67Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M90.12,136.95c-.44-4-3.05-5.59-6.46-5.89C84.27,134.43,86.1,136.89,90.12,136.95Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M79.36,121.1c.61,3.37,2.45,5.81,6.45,5.88C85.37,123,82.76,121.4,79.36,121.1Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M73.27,145.53c-.44-4-3.06-5.59-6.46-5.89C67.42,143,69.26,145.47,73.27,145.53Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M108.93,135.54c-.64,3.91,1.62,6,5.08,7.05C114.3,139.22,113.07,136.48,108.93,135.54Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M100.05,142c.17,4,2.84,5.6,6.45,5.91C106.11,144.51,104.33,142.05,100.05,142Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M86.48,155.08c3.73-1.55,4.53-4.52,3.87-7.89C87.28,148.72,85.43,151.18,86.48,155.08Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M102.36,94.53c-.44-4-3-5.58-6.45-5.88C96.52,92,98.36,94.47,102.36,94.53Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M102.09,100.41c-.44-4-3-5.59-6.45-5.88C96.26,97.9,98.09,100.34,102.09,100.41Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M105.6,104.35c4-.07,5.83-2.51,6.45-5.88C108.64,98.76,106,100.36,105.6,104.35Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				d="M111.08,88.66c-3.41.29-6,1.89-6.45,5.88C108.62,94.47,110.46,92,111.08,88.66Z"
				fill={fill}
			/>
		</svg>
	);
}
